// Browser-side JWT payload decoder.
//
// We do NOT verify signatures here — that's the backend's job, and trusting a
// browser-side verifier defeats the point. The SPA only needs the payload to
// (a) display the email/sub before the first /api/me call returns, and
// (b) schedule a refresh ahead of `exp`.

function base64urlDecode(s) {
    const pad = '='.repeat((4 - (s.length % 4)) % 4);
    const b64 = (s + pad).replace(/-/g, '+').replace(/_/g, '/');
    if (typeof globalThis.atob === 'function') {
        const bin = globalThis.atob(b64);
        let out = '';
        for (let i = 0; i < bin.length; i++) out += String.fromCharCode(bin.charCodeAt(i));
        return out;
    }
    // Node fallback.
    return Buffer.from(b64, 'base64').toString('binary');
}

export function decodeJwtPayload(token) {
    if (typeof token !== 'string') throw new Error('token must be a string');
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error('not a JWT');
    const json = decodeURIComponent(
        Array.from(base64urlDecode(parts[1]))
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''),
    );
    return JSON.parse(json);
}

/** Returns ms until expiry, or 0 if already expired or unparseable. */
export function msUntilExpiry(token, now = Date.now()) {
    try {
        const { exp } = decodeJwtPayload(token);
        if (typeof exp !== 'number') return 0;
        return Math.max(0, exp * 1000 - now);
    } catch {
        return 0;
    }
}
